import { OwcBadge, OwcButton, OwcTypography } from "@one/react";

const BookingsPaginationActions = ({ selectedCount, onCancelClick, disabled = false }) => {
  return (
    <span
      className="pagination"
      style={{
        display: "flex",
        padding: "0.25rem .25rem 0rem .25rem",
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <OwcBadge
          type="active"
          style={{
            width: "24px",
            height: "24px",
          }}
        >
          {selectedCount}
        </OwcBadge>
        <OwcTypography variant="body2">
          {selectedCount === 1 ? `Booking` : "Bookings"} added
        </OwcTypography>
      </div>
      <OwcButton
        variant="primary"
        onClick={onCancelClick}
        disabled={disabled || selectedCount === 0}
      >
        Cancel booking
      </OwcButton>
    </span>
  );
};

export default BookingsPaginationActions;
